import styled from 'styled-components'

export const OwnerListWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
`
